import { render, staticRenderFns } from "./ModalCertificadoDispensar.vue?vue&type=template&id=96722ad6&"
import script from "./ModalCertificadoDispensar.vue?vue&type=script&lang=js&"
export * from "./ModalCertificadoDispensar.vue?vue&type=script&lang=js&"
import style0 from "./ModalCertificadoDispensar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports